import { render, staticRenderFns } from "./agreement_alarm.vue?vue&type=template&id=b37499aa"
import script from "./agreement_alarm.vue?vue&type=script&lang=js"
export * from "./agreement_alarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports